import { Component,Inject } from '@angular/core';
import { ApiService } from 'app/api.service';
import { MatDialog,MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-quality-check-file-modal',
  templateUrl: './quality-check-file-modal.component.html',
  styleUrls: ['./quality-check-file-modal.component.scss']
})
export class QualityCheckFileModalComponent {
imageUrls: any[] = [];
documentUrls: any[] = [];
deleteIds: any[] = [];
selectedItems = false;
showLoader = false;
allItemIds: number[] = [];
  isViewMode: boolean;

constructor(
  private apiService: ApiService,
  private dialog: MatDialog,
  public dialogRef: MatDialogRef<QualityCheckFileModalComponent>,
  @Inject(MAT_DIALOG_DATA)
  public data: {
    id?: number;
    name?: string;
    uploadedFiles?: any[];
    images?: any[];
    isViewMode?: boolean;
  }
) {
  this.isViewMode = this.data.isViewMode || false;
  console.log('Fetched qc Data:', this.data);
}
ngOnInit(): void {
  this.showLoader = true;

  if (this.data.images) {
    this.processUploadedFiles(this.data.images);
  } else if (this.data.id) {
    this.fetchQcFilesById(this.data.id);
  }
}

  processUploadedFiles(files: any[]): void {
    this.imageUrls = [];
    this.documentUrls = [];

for (let file of files) {
  if (this.isImage(file)) {
    this.imageUrls.push(file);
  } else if (this.isDocument(file.extension)) {
    this.documentUrls.push(file);
  }
}

    this.showLoader = false;
  }
fetchQcFilesById(id: number): void {
  this.allItemIds = [];
  this.imageUrls = [];
  this.documentUrls = [];
  this.showLoader = true;

  this.apiService.getQcFiles(id).subscribe(
    (data: any) => {
      if (data.uploadedFiles && data.uploadedFiles.length) {
 for (let file of data.uploadedFiles) {
  if (this.isImage(file)) {
    this.imageUrls.push(file);
    this.allItemIds.push(file.id);
  } else if (this.isDocument(file.extension)) {
    this.documentUrls.push(file);
    this.allItemIds.push(file.id);
  }
  }
      }
      this.showLoader = false;
    },
    (error) => {
      console.error('Error fetching GRN files:', error);
      this.showLoader = false;
    }
  );
}

isImage(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && (
    filePath.toLowerCase().endsWith('.png') ||
    filePath.toLowerCase().endsWith('.jpg') ||
    filePath.toLowerCase().endsWith('.jpeg')
  );
}

isPDF(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && filePath.toLowerCase().endsWith('.pdf');
}

isDocument(extension: string): boolean {
  return ['pdf', 'doc', 'docx', 'xls', 'xlsx'].includes(extension.toLowerCase());
}

isPreviewable(extension: string): boolean {
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf'].includes(extension.toLowerCase());
}
onCheckboxChange(id: number, name: string): void {
  const index = this.deleteIds.findIndex(
    (item) => item.id === id && item.name === name
  );

  if (index === -1) {
    this.deleteIds.push({ id, name });
  } else {
    this.deleteIds.splice(index, 1);
  }

  this.selectedItems = this.deleteIds.length > 0;
}
  deleteImg(): void {
    const filesToDelete = this.deleteIds.map((file) => ({
      id: file.id,
      name: file.name,
    }));
    this.apiService.deleteQcImage(this.data.id, filesToDelete).subscribe(
      (response) => {
        console.log("Files deleted successfully:", response);
        alert("files deleted succesfully");

        this.imageUrls = this.imageUrls.filter(
          (file) =>
            !this.deleteIds.some(
              (delFile) => delFile.id === file.id && delFile.name === file.name )
            );
            
        this.documentUrls = this.documentUrls.filter(
          (file) =>
            !this.deleteIds.some(
              (delFile) => delFile.id === file.id && delFile.name === file.name)
        );
        this.deleteIds = [];
        this.fetchQcFilesById(this.data.id);
      },
      (error) => {
        console.error("Error deleting files:", error);
      },
      () => {
        this.showLoader = false;
      }
    );
    this.dialogRef.close();
  }
  cancel(): void {
    this.dialogRef.close();
  }

}
